import OPLUtility from "./OPL.Utility";
import OPLHeader from "./OPL.Header";
import OPLBackToTop from "./OPL.BackToTop";
import OPLMasthead from "./OPL.Masthead";
import OPLReadingLists from "./OPL.ReadingLists";
import OPLSwiper from "./OPL.Swiper";
import OPLFeaturedEvents from "./OPL.FeaturedEvents";
import OPLHomeBannerCarousel from "./OPL.HomeBannerCarousel";
import OPLResponsiveAccordionPanel from "./OPL.ResponsiveAccordionPanel";
import OPLLocations from "./OPL.Locations";
import OPLLoadMore from "./OPL.LoadMore";
import OPLAzureSearch from "./OPL.AzureSearch";
import OPLResourcesSearch from "./OPL.ResourcesSearch";
import OPLFederatedSearch from "./OPL.FederatedSearch";
import OPLRequestTitle from "./OPL.RequestTitle";
import OPLMyProfile from "./OPL.MyProfile";
import OPLPayFine from "./OPL.PayFine";
import OPLGetCard from "./OPL.GetCard";

export default class OPL {
    constructor() {
        this.Utility = new OPLUtility();
        this.Header = new OPLHeader();
        this.BackToTop = new OPLBackToTop();
        this.Masthead = new OPLMasthead();
        this.ReadingLists = new OPLReadingLists();
        this.Swiper = new OPLSwiper();
        this.FeaturedEvents = new OPLFeaturedEvents()
        this.HomeBannerCarousel = new OPLHomeBannerCarousel();
        this.ResponsiveAccordionPanel = new OPLResponsiveAccordionPanel();
        this.Locations = new OPLLocations();
        this.LoadMore = new OPLLoadMore();
        this.AzureSearch = new OPLAzureSearch();
        this.ResourcesSearch = new OPLResourcesSearch();
        this.FederatedSearch = new OPLFederatedSearch();
        this.RequestTitle = new OPLRequestTitle();
        this.MyProfile = new OPLMyProfile();
        this.PayFine = new OPLPayFine();
        this.GetCard = new OPLGetCard();
    }
    
    // On DOM ready (callback)
    onDomReadyCallback() {
        // Init before frameworks
        this.init();
        
        // Init after frameworks
        this.initAfterFrameworks();
    }


    // Init before frameworks
    init() {
        for (var i in this) {
            if (typeof this[i].init === 'function') {
                this[i].init();
            }
        }
    }
    
    // Init after frameworks
    initAfterFrameworks() {
        for (var i in this) {

            if (typeof this[i].initAfterFrameworks === 'function') {
                this[i].initAfterFrameworks();

            }
        }
    }
}
